import { z } from 'zod';
import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi';
extendZodWithOpenApi(z);
export const JobQuerySchema = z.object({
    type: z.string().optional().openapi({
        description: 'Filter by job type',
        example: 'course_generation',
    }),
    status: z.string().optional().openapi({
        description: 'Filter by job status',
        example: 'completed',
    }),
});
export const JobIdParamSchema = z.object({
    jobId: z.string().uuid().openapi({
        description: 'Background job UUID',
        example: '550e8400-e29b-41d4-a716-446655440000',
    }),
});
export const BackgroundJobSchema = z
    .object({
    id: z.string().uuid().openapi({
        description: 'Unique identifier for the background job',
        example: '550e8400-e29b-41d4-a716-446655440000',
    }),
    type: z.string().openapi({
        description: 'Type of background job',
        example: 'course_generation',
    }),
    status: z.string().openapi({
        description: 'Current status of the job',
        example: 'completed',
    }),
    userId: z.string().uuid().openapi({
        description: 'UUID of the user who initiated the job',
        example: '660e8400-e29b-41d4-a716-446655440001',
    }),
    entityId: z.string().uuid().nullable().openapi({
        description: 'UUID of the entity the job relates to, if applicable',
        example: '770e8400-e29b-41d4-a716-446655440002',
    }),
    entityType: z.string().nullable().openapi({
        description: 'Type of entity the job relates to (e.g. course, module)',
        example: 'course',
    }),
    input: z.unknown().openapi({
        description: 'Input parameters provided when the job was created',
    }),
    progress: z.unknown().nullable().openapi({
        description: 'Current progress data for the job, if available',
    }),
    result: z.unknown().nullable().openapi({
        description: 'Result data returned upon job completion, if available',
    }),
    errorMessage: z.string().nullable().openapi({
        description: 'Error message if the job failed',
        example: null,
    }),
    retryCount: z.number().openapi({
        description: 'Number of times the job has been retried',
        example: 0,
    }),
    maxRetries: z.number().openapi({
        description: 'Maximum number of retries allowed for this job',
        example: 3,
    }),
    startedAt: z.string().datetime().nullable().openapi({
        description: 'ISO 8601 timestamp when the job started processing',
        example: '2026-02-27T10:00:00.000Z',
    }),
    completedAt: z.string().datetime().nullable().openapi({
        description: 'ISO 8601 timestamp when the job finished',
        example: '2026-02-27T10:05:00.000Z',
    }),
    acknowledgedAt: z.string().datetime().nullable().openapi({
        description: 'ISO 8601 timestamp when the user acknowledged a terminal job',
        example: null,
    }),
    createdAt: z.string().datetime().openapi({
        description: 'ISO 8601 timestamp when the job was created',
        example: '2026-02-27T09:59:00.000Z',
    }),
    updatedAt: z.string().datetime().openapi({
        description: 'ISO 8601 timestamp when the job was last updated',
        example: '2026-02-27T10:05:00.000Z',
    }),
})
    .openapi('BackgroundJob');
//# sourceMappingURL=job.schema.js.map